'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/web.url.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.url.js
// module id = 1550
// module chunks = 0